/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ShippingChargeDialog.vue?vue&type=template&id=fe4fc3ea"
import script from "./ShippingChargeDialog.vue?vue&type=script&lang=js"
export * from "./ShippingChargeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe4fc3ea')) {
      api.createRecord('fe4fc3ea', component.options)
    } else {
      api.reload('fe4fc3ea', component.options)
    }
    module.hot.accept("./ShippingChargeDialog.vue?vue&type=template&id=fe4fc3ea", function () {
      api.rerender('fe4fc3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/ShippingChargeDialog.vue"
export default component.exports